// extracted by mini-css-extract-plugin
export default {"projectName":"projects-selector-item_projectName__QOD-v","projectContainer":"projects-selector-item_projectContainer__bawkU","link":"projects-selector-item_link__r2dDC"};